import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ListDataSkeleton from "../../components/template/skeleton/ListDataSkeleton";
import BillingInvoiceSearch from "../../components/molecules/billingInvoice/BillingInvoiceSearch";
import BillingInvoiceTable from "../../components/molecules/billingInvoice/BillingInvoiceTable";
import { useGetAllBillingQuery } from "../../store/feature/service/billingInvoiceApiSlice";

const BillingInvoice = () => {
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});
  const { data, isLoading } = useGetAllBillingQuery(params);

  // REGION: DISPATCH OCSP ALL
  useEffect(() => {
    // dispatch(getAllOcspList(params));
  }, [params]);

  // REGION: RETURN TSX
  return (
    <ListDataSkeleton
      isLoading={isLoading}
      isLoadingEvent={false}
      titleWidth={"300px"}
    >
      <Box>
        <Typography
          variant="h3"
          fontFamily="Open Sans"
          sx={{ marginY: "20px" }}
          >
          Billing
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
        </Box>
        <BillingInvoiceSearch params={params} setParams={setParams} />
        <BillingInvoiceTable
          data={data !== undefined || null ? data : []}
          params={params}
          setParams={setParams}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
      </Box>
    </ListDataSkeleton>
  );
};

export default BillingInvoice;
